// extracted by mini-css-extract-plugin
module.exports = {"MobHeader":"MobHeader_MobHeader__ZGTNo","Transparent":"MobHeader_Transparent__htIYW"};